var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"applicationDescription",domProps:{"innerHTML":_vm._s(_vm.desc)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }